import React, { Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

// ActionCreators

import { changePage, changeData } from '@actions/ssap/ssapActionCreators';
import { householdMemberTools } from '@utils/tools/householdMemberTools';


const HyperButtons = props => {

    const {
        adjustedFlow,
        environment: {
            isState
        },
        householdMembers,
        page
    } = props;
    
    const tooltipWidth = 250;

    const handleClick = e => {
        const {
            name
        } = e.currentTarget;

        props.actions.changePage(+name);
    };

    const getReasons = reasons => {
        return reasons.map((reason, i) => (
            <div key={`${reason}_${i}`} style={{ color: 'black' }}>
                {`${reason};`}
            </div>
        ));
    };

    const handleMouseEnter = (e, i) => {
        const el = e.currentTarget.parentElement.getElementsByClassName(i)[0];

        const ssapContainerWidth =
            Number(window
                .getComputedStyle(document.querySelector('html'))
                .width
                .split('px')[0]);
        
        const horizontalPosition = (() => {
            switch(true) {
                case e.pageX < ssapContainerWidth/2:
                    return 'right';
                default:
                    return 'left';
            }
        })();
        
        el.style.position = 'absolute';
        el.style[horizontalPosition] = 0;
        el.style.top = 0;
        el.style.display = 'block';
    };

    const handleMouseLeave = (e, i) => {
        e.currentTarget.parentElement.getElementsByClassName(i)[0].style.display = 'none';
    };


    return (
        <div
            style={{ position: 'relative', padding: 0,  margin: '0px 20px' }}
        >
            {
                adjustedFlow.map((currentPage, i) => {
                    return (
                        <Fragment key={i}>
                            <div
                                style={{
                                    display: 'none' ,
                                    width: `${tooltipWidth}px`,
                                    minHeight: '100px',
                                    backgroundColor: 'orange',
                                    border: '1px solid black',
                                    borderRadius: '5px',
                                    textAlign: 'left',
                                    padding: '2px',
                                    fontSize: '1.2rem',
                                    zIndex: 500
                                }}
                                className={`paginator-btn-tooltip ${i}`}
                            >
                                <div style={{
                                    color: 'darkred',
                                    fontWeight: 'bold'
                                }}>
                                    {isState.MN ? currentPage.page.navBarText : <FormattedMessage id={currentPage.page.navBarText}/>}
                                </div>
                                <div style={{
                                    color: 'darkred',
                                    fontWeight: 'bold'
                                }}>
                                    { currentPage.componentName }
                                </div>
                                <div>
                                    {
                                        currentPage.reasons.length !== 0 ?
                                            getReasons(currentPage.reasons) :
                                            null
                                    }
                                </div>
                                <div>
                                    {
                                        currentPage.hhm !== -1 && currentPage.hhm < householdMembers.length ?
                                            <span
                                                style={{
                                                    fontWeight: 'bold'
                                                }}
                                            >
                                            Page for: &nbsp;
                                                {
                                                    householdMemberTools
                                                        .extractFromHouseholdMembers(householdMembers)
                                                        .getFullNameByHhmIndexInArray(currentPage.hhm)
                                                }
                                                <br/>
                                            Hhm&apos;s GUID: &nbsp;
                                                {
                                                    householdMemberTools
                                                        .extractFromHouseholdMembers(householdMembers)
                                                        .getGuidByIndexInArray(currentPage.hhm)
                                                }
                                            </span> : null
                                    }
                                </div>
                            </div>
                            <button
                                name={i}
                                onClick={handleClick}
                                style={{
                                    width: String(i).length < 3 ? '22px' : '30px',
                                    padding: '2px',
                                    margin: '2px',
                                    fontSize: '0.7rem !important',
                                    borderRadius: '5px',
                                    border: `1px solid ${page === i ? 'red' : 'black'}`,
                                    color: currentPage.isActive ? 'black' : 'white',
                                    backgroundColor: currentPage.isActive ? '#00a6d2' : 'black',
                                    outline: 'none',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={e => handleMouseEnter(e, i)}
                                onMouseLeave={e => handleMouseLeave(e, i)}
                            >
                                <span>
                                    { i }
                                </span>
                                {
                                    currentPage.hhm !== -1 &&

                                    <Fragment>
                                        <hr style={{ padding: 0, margin: 0 }}/>
                                        { currentPage.hhm }
                                    </Fragment>
                                }
                            </button>
                        </Fragment>


                    );
                })
            }



        </div>
    );
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData,
        changePage
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(HyperButtons);
